import Modules from '@/model/modules';
import {RouteModule} from '@/types/route-type';
import FundDetail from './fund-detail/fund-detail';
import FundList from './fund-list/fund-list';

const Module: RouteModule = {
    module: Modules.FUND,
    pages: [
        {
            path: '/fund',
            element: FundList,
        },
        {
            path: '/fund/:id',
            element: FundDetail,
        },
    ],
};

export default Module;
